/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSharedDetailBust_item = {|
  +measurement: ?{|
    +bust: ?$ReadOnlyArray<?{| |}>;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailBust_item",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "ItemMeasurement",
      "name": "measurement",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "bust",
          "args": [
            {
              "kind": "Literal",
              "name": "fields",
              "value": [
                "chest"
              ],
              "type": "[measurementFieldType]"
            }
          ],
          "concreteType": "ItemDisplayMeasurementType",
          "name": "display",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpSharedDetailMeasurement_measurements",
              "args": null
            }
          ],
          "storageKey": "display{\"fields\":[\"chest\"]}"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item"
};

module.exports = fragment;
